'use strict';

(function ($) {
	$(function () {
		const $modalTrigger = $('.js-modal-trigger'),
			$modalClose = $('.js-modal-close'),
			$modalOverlay = $('.js-modal-overlay'),
			$modalContent = $('.modal'),
			$modalStart = $modalContent.find('input:not(.gform_hidden)').first();

		$modalTrigger.on('click', displayModal);
		$modalClose.on('click', displayModal);
		$modalOverlay.on('click', displayModal);

		function displayModal() {
			if ($modalContent.hasClass('is-zoomed')) {
				//close modal
				$modalContent.removeClass('is-zoomed');
				$modalContent.attr('aria-hidden', true);
				$modalContent.siblings('#page').attr('aria-hidden', false);
				$modalTrigger.focus();
			} else {
				$modalContent.addClass('is-zoomed');
				$modalContent.attr('aria-hidden', false);
				$modalContent.siblings('#page').attr('aria-hidden', true);
				$modalStart.focus();
			}
		}

		$(document).ready(function () {
			if (document.cookie.indexOf('popup=true') === -1) {
				document.cookie = 'popup=true; max-age=1296000; path=/'; // 30 days in seconds

				setTimeout(function () {
					displayModal();
				}, 10000);
			}
		});
	});
})(jQuery);
